import {fetchBaseQuery} from '@reduxjs/toolkit/dist/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  mode: 'cors',
  prepareHeaders: (headers, {getState}) => {
    // const {
    //   user: {token},
    // } = getState();
    // // const {token} = state?.user || null;
    // // const csrf = Cookies.get('csrftoken')
    // //
    // if (token) {
    //   headers.set('Authorization', `Bearer ${token}`);
    // }

    return headers;
  },
});

export default baseQuery;
